/**************************************************
 * Nombre:       Pdf_Documento
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {React} from 'react';
import {Page, Text, View, Document, StyleSheet, Font, Image} from '@react-pdf/renderer';
import f400 from '../Recursos/Roboto-Light.ttf'
import f500 from '../Recursos/Roboto-Regular.ttf'
import f600 from '../Recursos/Roboto-Medium.ttf'
import f700 from '../Recursos/Roboto-Bold.ttf'
import f800 from '../Recursos/Roboto-Black.ttf'
import logo from '../Recursos/logo.png'
import {TagUser} from "iconsax-react";
import {getFechaTimestampSencillo} from "../../Utilidades/getFechaTimestampSencillo";
import {getFechaTimestamp} from "../../Utilidades/getFechaTimestamp";


const Pdf_Cheking = ({item}) => {
    Font.register({family: '400', src: f400})
    Font.register({family: '500', src: f500})
    Font.register({family: '600', src: f600})
    Font.register({family: '700', src: f700})
    Font.register({family: '800', src: f800})


    const styles = StyleSheet.create({
        page: {
            flexDirection: 'column',
            backgroundColor: '#fff',
            padding: 28
        },
        gitc: {
            flexDirection: 'column',
            width: '100%'
        },
        git: {
            flexDirection: 'row',
            width: '100%'
        },
        gitf: {
            flexDirection: 'row',
            justifyContent: "flex-end",
            width: '100%'
        },
        gitcenter: {
            flexDirection: 'row',
            justifyContent: "center",
            width: '100%'
        },
        git20: {
            flexDirection: 'row',
            width: '20%'
        },
        git80: {
            flexDirection: 'row',
            width: '80%'
        },
        git50: {
            flexDirection: 'row',
            width: '50%'
        },
        git50f: {
            flexDirection: 'row',
            justifyContent: "flex-end",
            width: '50%'
        },
        imagen: {
            width: 160,
            height: 40,
            marginTop: 8,
        },
        texTitulo: {
            fontSize: 20,
            fontFamily: '800'
        },
        texMed: {
            fontSize: 12,
            fontFamily: '500'
        },
        texMedB: {
            fontSize: 12,
            fontFamily: '700'
        },
        texMinCep: {
            fontSize: 10,
            fontFamily: '500',
            color: '#00000070'
        },
        texMin: {
            fontSize: 8,
            fontFamily: '500'
        },
        texTab: {
            fontSize: 10,
            fontFamily: '400'
        },
        texTabB: {
            fontSize: 10,
            fontFamily: '600',
            textAling: 'rigth'
        }

    });


    const Cabecera = () => {
        return (
            <View style={styles.git}>
                <View style={styles.git50}>
                    <Image src={logo} style={styles.imagen}/>
                </View>

                <View style={styles.git50f}>
                    <View style={styles.gitc}>
                        <View style={styles.gitf}>
                            <Text style={styles.texTitulo}>LISTA DE CHEQUEO</Text>
                        </View>
                        <View style={styles.gitf}>
                            <Text style={styles.texMin}>Código: RE-GO-001</Text>
                        </View>
                        <View style={styles.gitf}>
                            <Text style={styles.texMin}>Version: 2</Text>
                        </View>

                        <View style={{...styles.gitf, marginTop: 1}}>
                            <Text style={styles.texMin}>Emisión: 04/12/2023</Text>
                        </View>

                    </View>
                </View>

            </View>
        )
    }

    const Ceparador = ({texto}) => {

        return (
            <View style={styles.git}>
                <View style={styles.git20}>
                    <Text style={styles.texMinCep}>{texto}</Text>
                </View>
                <View style={styles.git80}>
                    <Text style={{
                        ...styles.texMinCep,
                        marginTop: -2
                    }}>_________________________________________________________________________________________________</Text>
                </View>
            </View>
        )

    }

    const Fecha = ({item}) => {
        return (
            <View style={styles.git}>

                <View style={styles.git50}>
                    <Text
                        style={styles.texMed}>{'Fecha de creacion: ' + getFechaTimestampSencillo(item.fecha)}</Text>
                </View>
                <View style={styles.git50f}>
                    {item.estado === 'aprobado' &&
                        <Text
                            style={styles.texMed}>{'Aprobado por : ' + item.aprobo}</Text>
                    }
                </View>

            </View>
        )
    }

    const TituloDato = ({titulo, dato, wtitulo = '40%', wdato = '60%'}) => {

        return (
            <View style={{...styles.git, marginBottom: 4}}>
                <View style={{...styles.git, width: wtitulo}}>
                    <Text style={styles.texMedB}>{titulo + ': '}</Text>
                </View>

                <View style={{...styles.git, width: wdato}}>
                    <Text style={styles.texMed}>{dato}</Text>
                </View>
            </View>
        )

    }

    const DatosConductor = ({item}) => {
        return (
            <View style={{...styles.git, paddingLeft: 10,}}>
                <View style={styles.gitc}>

                    <View style={styles.git}>
                        <View style={{...styles.git, width: '66.5%'}}>
                            <TituloDato titulo={'Nombres y Apellidos'} dato={item.nombre}
                                        wtitulo={'35%'} wdato={'65%'}/>
                        </View>
                        <View style={{...styles.git, width: '32.5%'}}>
                            <TituloDato titulo={'Cedula #'} dato={item.cc} wtitulo={'40%'} wdato={'60%'}/>
                        </View>
                    </View>

                    <View style={styles.git}>
                        <View style={{...styles.git, width: '66.5%'}}>
                            <TituloDato titulo={'Licencia o Pase'} dato={item.pase}
                                        wtitulo={'35%'} wdato={'65%'}/>
                        </View>

                        <View style={{...styles.git, width: '32.5%'}}>
                            <TituloDato titulo={'Celular'} dato={item.celular} wtitulo={'40%'} wdato={'60%'}/>
                        </View>

                    </View>

                    <View style={styles.git}>
                        <View style={{...styles.git, width: '66.5%'}}>
                            <TituloDato titulo={'Eps'} dato={item.eps}
                                        wtitulo={'35%'} wdato={'65%'}/>
                        </View>
                        <View style={{...styles.git, width: '32.5%'}}>
                            <TituloDato titulo={'ARP'} dato={item.arp} wtitulo={'40%'} wdato={'60%'}/>
                        </View>
                    </View>

                    <View style={styles.git}>
                        <View style={{...styles.git, width: '66.5%'}}>
                            <TituloDato titulo={'Vigencia Hasta'} dato={getFechaTimestampSencillo(item.vigente)}
                                        wtitulo={'35%'} wdato={'65%'}/>
                        </View>


                    </View>

                </View>
            </View>
        )
    }


    const DatosGPS = ({item}) => {
        return (
            <View style={{...styles.git, paddingLeft: 10,}}>
                <View style={styles.gitc}>

                    <View style={styles.git}>
                        <View style={{...styles.git, width: '66.5%'}}>
                            <TituloDato titulo={'Empresa Satelital'} dato={item.link}
                                        wtitulo={'35%'} wdato={'65%'}/>
                        </View>
                        <View style={{...styles.git, width: '32.5%'}}>
                            <TituloDato titulo={'Cuenta'} dato={item.cuenta} wtitulo={'40%'} wdato={'60%'}/>
                        </View>
                    </View>

                    <View style={styles.git}>
                        <View style={{...styles.git, width: '66.5%'}}>
                            <TituloDato titulo={'Usuario'} dato={item.usuario}
                                        wtitulo={'35%'} wdato={'65%'}/>
                        </View>

                        <View style={{...styles.git, width: '32.5%'}}>
                            <TituloDato titulo={'Clave'} dato={item.clave} wtitulo={'40%'} wdato={'60%'}/>
                        </View>

                    </View>

                </View>
            </View>
        )
    }

    const DatosVehiculo = ({item}) => {
        return (
            <View style={{...styles.git, paddingLeft: 10,}}>
                <View style={styles.gitc}>

                    <View style={styles.git}>
                        <View style={{...styles.git, width: '40%'}}>
                            <TituloDato titulo={'Placa'} dato={item.placa}
                                        wtitulo={'35%'} wdato={'65%'}/>
                        </View>

                        <View style={{...styles.git, width: '40%'}}>
                            <TituloDato titulo={'Tipo'} dato={item.tipo}
                                        wtitulo={'35%'} wdato={'65%'}/>
                        </View>

                        <View style={{...styles.git, width: '40%'}}>
                            <TituloDato titulo={'Num Ejes'} dato={item.ejes}
                                        wtitulo={'35%'} wdato={'65%'}/>
                        </View>

                    </View>

                    <View style={styles.git}>
                        <View style={{...styles.git, width: '40%'}}>
                            <TituloDato titulo={'Carroseria'} dato={item.carroseria}
                                        wtitulo={'35%'} wdato={'65%'}/>
                        </View>

                        <View style={{...styles.git, width: '40%'}}>
                            <TituloDato titulo={'Cap. en KG'} dato={item.tara}
                                        wtitulo={'35%'} wdato={'65%'}/>
                        </View>

                        <View style={{...styles.git, width: '40%'}}>
                            <TituloDato titulo={'Color'} dato={item.color}
                                        wtitulo={'35%'} wdato={'65%'}/>
                        </View>

                    </View>

                    <View style={styles.git}>
                        <View style={{...styles.git, width: '40%'}}>
                            <TituloDato titulo={'Linea'} dato={item.modelo}
                                        wtitulo={'35%'} wdato={'65%'}/>
                        </View>

                        <View style={{...styles.git, width: '40%'}}>
                            <TituloDato titulo={'Año'} dato={item.year}
                                        wtitulo={'35%'} wdato={'65%'}/>
                        </View>

                        <View style={{...styles.git, width: '40%'}}>
                            <TituloDato titulo={'Motor #'} dato={item.motor}
                                        wtitulo={'35%'} wdato={'65%'}/>
                        </View>

                    </View>

                    <View style={styles.git}>
                        <View style={{...styles.git, width: '40%'}}>
                            <TituloDato titulo={'Chasis #'} dato={item.chasis}
                                        wtitulo={'29%'} wdato={'71%'}/>
                        </View>
                    </View>


                </View>
            </View>
        )
    }

    const UnidadChequeada = ({datos, nombre}) => {

        return (
            <View style={{...styles.git, marginTop: 20}}>

                <View style={styles.gitc}>
                    <View style={styles.git}>
                        <Text style={styles.texMedB}>{nombre}</Text>
                    </View>

                    <View style={styles.gitcenter}>
                        <Image src={datos.img} style={{width: '80%', padding: 40}}/>
                    </View>


                    <View style={{...styles.gitc, paddingLeft: 10, paddingRight: 10, marginTop: 8}}>
                        {
                            Object.entries(datos).map(([key, value]) => {

                                if (key === 'img') {
                                    return ''
                                } else {

                                    return (
                                        <View
                                            style={{
                                                ...styles.git,
                                                borderBottom: 0.5,
                                                padding: 2,
                                                borderColor: '#00000070'
                                            }}>
                                            <View style={styles.git80}>
                                                <Text style={styles.texTab}>{key}</Text>
                                            </View>
                                            <View style={{...styles.gitf, width: '20%'}}>
                                                <Text style={styles.texTabB}>{value}</Text>
                                            </View>

                                        </View>
                                    )
                                }
                            })
                        }
                    </View>
                </View>

            </View>
        )
    }

    const ParrafoFirma = ({item}) => {
        return (
            <View style={styles.git}>
                <View style={{...styles.git, width: '100%', padding: 10}}>
                    <View style={styles.gitc}>
                        <View>
                            <Text style={styles.texTabB}>Para International Logistics MD S.A.S:</Text>
                        </View>
                        <View>
                            <Text style={styles.texTab}>{'Yo '}
                                <Text style={styles.texTab}>{item.nombre}</Text>
                                {' identificado con cedula # '}
                                <Text style={styles.texTab}>{item.cc}</Text>
                                {' certifico que la información anteriormente suministrada es verdadera y que podrá ser confirmada mediante estudio de seguridad, además de proporcionar fotos reales del día en el que se realiza la inspección.'}
                            </Text>
                        </View>

                    </View>
                </View>

                <View style={{...styles.git, width: '50%', padding: 10, marginTop: 10}}>
                    {item.firma &&
                        <View style={styles.gitc}>

                            <View>
                                <Image src={item.firma}/>
                            </View>

                            <View style={{...styles.gitf, marginTop: -20}}>
                                <Text
                                    style={styles.texMin}>{'Fecha de Firma: ' + getFechaTimestampSencillo(item.fechaDiligenciado)}</Text>
                            </View>

                        </View>
                    }
                </View>

            </View>
        )
    }

    return (
        <Document>
            <Page size={'letter'} style={styles.page}>

                <Cabecera/>

                <View style={{marginTop: 20}}/>

                <Fecha item={item}/>

                <View style={{marginTop: 20}}/>

                <Ceparador texto={'Datos del conductor'}/>

                <View style={{marginTop: 10}}/>

                <DatosConductor item={item}/>

                <View style={{marginTop: 10}}/>

                <Ceparador texto={'Datos del vehiculo'}/>

                <View style={{marginTop: 10}}/>

                <DatosVehiculo item={item}/>

                <View style={{marginTop: 10}}/>

                <Ceparador texto={'Datos GPS'}/>

                <View style={{marginTop: 10}}/>

                <DatosGPS item={item}/>

                <View style={{marginTop: 10}}/>

                {item && item.datos &&
                    <>

                        {item.datos.frente &&
                            <UnidadChequeada datos={item.datos.frente} nombre={'Unidad de Transporte de Carga'}/>
                        }

                        {item.datos.unidad &&
                            <UnidadChequeada datos={item.datos.unidad} nombre={'Unidad Carga'}/>
                        }

                        {item.datos.furgon &&
                            <UnidadChequeada datos={item.datos.furgon} nombre={'Para Furgon'}/>
                        }

                        {item.datos.cisterna &&
                            <UnidadChequeada datos={item.datos.cisterna} nombre={'Para Cisterna'}/>
                        }

                        {item.datos.plataforma &&
                            <UnidadChequeada datos={item.datos.plataforma}
                                             nombre={'Para Plataforma Chais y Similares'}/>
                        }

                        {item.datos.camion &&
                            <UnidadChequeada datos={item.datos.camion}
                                             nombre={'Para Camiones (tractores / cabezales)'}/>
                        }

                        {item.datos.interior &&
                            <UnidadChequeada datos={item.datos.interior} nombre={'Complementarios'}/>
                        }

                    </>
                }

                <View style={{marginTop: 20}}/>

                <Ceparador texto={'Observaciones'}/>

                <ParrafoFirma item={item}/>


            </Page>
        </Document>
    )
}

export default Pdf_Cheking;


const srcImg = 'data:image/png;base64,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'